import styled, { keyframes, css } from 'styled-components'

// ── paleta (alinhada à página central de relatórios) ───────────────
const TEAL = 'var(--teal)'
const TEAL_TEXT = 'var(--teal-text, var(--teal))';
const TEAL_LIGHT = 'var(--teal-light)'
const TEAL_SOFT = 'var(--teal-soft)'
const GRAY_BG = 'var(--bg)'
const GRAY_LINE = 'var(--line)'
const GRAY_TEXT = 'var(--text-muted)'
const GREEN = 'var(--green)'
const GREEN_SOFT = 'var(--green-soft)'
const AMBER = 'var(--amber, #d97706)'
const RED = 'var(--red, #dc2626)'

const bp = {
    desktop: '1024px',
    tablet: '768px',
    mobile: '540px',
    small: '380px'
}

const expand = keyframes`
    from { opacity: 0; transform: translateY(-6px); }
    to   { opacity: 1; transform: translateY(0); }
`

const shimmer = keyframes`
    0%   { background-position: -400px 0; }
    100% { background-position: 400px 0; }
`

export const Container = styled.div`
    width: 100%;
    min-height: 100vh;
    background: ${GRAY_BG};
    padding: 16px;
    display: flex;
    justify-content: center;
    box-sizing: border-box;

    @media (max-width: ${bp.tablet}) { padding: 12px; }
    @media (max-width: ${bp.mobile}) { padding: 8px; }
`

export const ContainerDivs = styled.div`
    width: 100%;
    max-width: 960px;
    display: flex;
    flex-direction: column;
    gap: 14px;

    @media (max-width: ${bp.mobile}) { gap: 10px; }
`

/* ── Header ─────────────────────────────────────────────────────── */

export const Header = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 18px 20px;
    background: ${TEAL};
    color: #fff;
    border-radius: 14px;
    box-shadow: 0 6px 18px rgba(0, 62, 79, 0.18);
    flex-wrap: wrap;

    @media (max-width: ${bp.mobile}) {
        padding: 14px 16px;
        border-radius: 12px;
    }
`

export const HeaderInfo = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    text-align: left;
    min-width: 0;
`

export const Title = styled.h1`
    margin: 0;
    font-size: 20px;
    font-weight: 700;
    letter-spacing: 0.2px;

    @media (max-width: ${bp.mobile}) { font-size: 17px; }
    @media (max-width: ${bp.small}) { font-size: 16px; }
`

export const Subtitle = styled.span`
    font-size: 12px;
    font-weight: 600;
    opacity: 0.85;
    text-transform: uppercase;
    letter-spacing: 0.4px;
`

export const HeaderBadge = styled.span`
    background: rgba(255, 255, 255, 0.18);
    color: #fff;
    font-size: 12px;
    padding: 6px 12px;
    border-radius: 999px;
    font-weight: 600;
    white-space: nowrap;
`

/* ── Toolbar / busca ────────────────────────────────────────────── */

export const Toolbar = styled.div`
    display: flex;
    gap: 8px;
    align-items: center;
    flex-wrap: wrap;
    background: var(--surface);
    border: 1px solid ${GRAY_LINE};
    border-radius: 12px;
    padding: 10px 12px;

    @media (max-width: ${bp.mobile}) { padding: 8px 10px; gap: 6px; }
`

export const SearchInput = styled.input`
    flex: 1;
    min-width: 200px;
    border: 1px solid ${GRAY_LINE};
    background: var(--surface);
    border-radius: 8px;
    padding: 10px 12px;
    font-size: 14px;
    color: ${TEAL_TEXT};
    outline: none;
    transition: border-color .15s ease, box-shadow .15s ease;

    &:focus {
        border-color: ${TEAL_LIGHT};
        box-shadow: 0 0 0 3px rgba(10, 90, 115, 0.10);
    }

    @media (max-width: ${bp.mobile}) {
        min-width: 100%;
        font-size: 16px;
        min-height: 44px;
    }
`

export const Badge = styled.span`
    background: ${TEAL};
    color: #fff;
    font-size: 11px;
    padding: 3px 8px;
    border-radius: 999px;
    font-weight: 600;
    white-space: nowrap;
`

/* ── Select de período (fallback) ──────────────────────────────── */

export const InputArea = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    background: var(--surface);
    border: 1px solid ${GRAY_LINE};
    border-radius: 14px;
    padding: 22px;

    @media (max-width: ${bp.mobile}) { padding: 16px; }
`

export const Label = styled.label`
    font-size: 12px;
    font-weight: 600;
    color: ${GRAY_TEXT};
    text-transform: uppercase;
    letter-spacing: 0.3px;
`

export const Select = styled.select`
    border: 1px solid ${GRAY_LINE};
    background: var(--surface);
    border-radius: 8px;
    padding: 10px 12px;
    font-size: 14px;
    color: ${TEAL_TEXT};
    outline: none;
    cursor: pointer;
    transition: border-color .15s ease, box-shadow .15s ease;
    min-height: 42px;
    width: 100%;
    box-sizing: border-box;

    &:focus {
        border-color: ${TEAL_LIGHT};
        box-shadow: 0 0 0 3px rgba(10, 90, 115, 0.12);
    }

    @media (max-width: ${bp.mobile}) { font-size: 16px; min-height: 44px; }
`

/* ── Seção (cada bloco de lista de alunos) ─────────────────────── */

export const Section = styled.section`
    background: var(--surface);
    border: 1px solid ${GRAY_LINE};
    border-radius: 14px;
    overflow: hidden;

    @media (max-width: ${bp.mobile}) { border-radius: 12px; }
`

export const SectionHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    padding: 14px 18px;
    background: ${({ $tone }) => ($tone === 'done' ? GREEN_SOFT : TEAL_SOFT)};
    border-bottom: 1px solid ${GRAY_LINE};

    @media (max-width: ${bp.mobile}) { padding: 12px 14px; }
`

export const SectionTitle = styled.span`
    font-weight: 700;
    font-size: 14px;
    color: ${({ $tone }) => ($tone === 'done' ? GREEN : TEAL)};
    display: flex;
    align-items: center;
    gap: 8px;

    @media (max-width: ${bp.mobile}) { font-size: 13px; }
`

export const SectionHint = styled.p`
    margin: 0;
    padding: 10px 18px 0;
    color: ${GRAY_TEXT};
    font-size: 13px;

    @media (max-width: ${bp.mobile}) { padding: 8px 14px 0; }
`

/* ── Lista de alunos ────────────────────────────────────────────── */

export const List = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 12px;

    @media (max-width: ${bp.mobile}) { padding: 8px; gap: 6px; }
`

// item base, com variação de cor por status
const itemBase = css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 14px 16px;
    border-radius: 10px;
    cursor: pointer;
    border: 1px solid transparent;
    text-align: left;
    width: 100%;
    transition: transform .12s ease, box-shadow .12s ease, background .15s ease;

    &:hover { transform: translateY(-1px); box-shadow: 0 4px 12px rgba(0,0,0,.06); }
    &:active { transform: translateY(0); }
    &:focus-visible { outline: 2px solid ${TEAL_LIGHT}; outline-offset: 2px; }

    @media (max-width: ${bp.mobile}) { padding: 12px 14px; }
`

// aluno sem relatório (ação: adicionar)
export const EmpStdt = styled.button`
    ${itemBase}
    background: var(--teal-soft);
    border-color: var(--teal-soft);
    color: ${TEAL_TEXT};
    &:hover { background: ${TEAL_SOFT}; }
`

// aluno com relatório (ação: ver/editar)
export const EmpChecked = styled.button`
    ${itemBase}
    background: ${GREEN_SOFT};
    border-color: #cdeac8;
    color: ${GREEN};
    &:hover { background: #d6efd2; }
`

export const Span = styled.span`
    font-size: 14px;
    font-weight: 600;
    overflow-wrap: anywhere;

    @media (max-width: ${bp.small}) { font-size: 13px; }
`

// pequena etiqueta à direita do item ("Adicionar" / "Ver")
export const ItemTag = styled.span`
    font-size: 11px;
    font-weight: 700;
    padding: 4px 10px;
    border-radius: 999px;
    white-space: nowrap;
    background: ${({ $tone }) => ($tone === 'done' ? '#cdeac8' : 'var(--teal-soft)')};
    color: ${({ $tone }) => ($tone === 'done' ? GREEN : TEAL)};
`

/* ── Estado vazio ───────────────────────────────────────────────── */

export const EmptyState = styled.div`
    background: var(--surface);
    border: 1px dashed ${GRAY_LINE};
    border-radius: 12px;
    padding: 28px;
    text-align: center;
    color: ${GRAY_TEXT};
    font-size: 14px;

    @media (max-width: ${bp.mobile}) { padding: 20px 16px; }
`

/* ── Aviso de período fechado ──────────────────────────────────── */

export const ClosedNotice = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    background: var(--surface);
    border: 1px solid var(--red);
    border-left: 4px solid ${RED};
    border-radius: 12px;
    padding: 22px;
    color: ${RED};
    font-size: 14px;
    font-weight: 600;
    text-align: center;

    @media (max-width: ${bp.mobile}) { padding: 16px; }
`

/* ── Skeleton (carregamento) ───────────────────────────────────── */

const skeletonBase = css`
    background: linear-gradient(90deg, var(--skel-a) 0%, var(--skel-b) 50%, var(--skel-a) 100%);
    background-size: 800px 100%;
    animation: ${shimmer} 1.3s linear infinite;
    border-radius: 8px;
`

export const SkeletonLine = styled.div`
    ${skeletonBase}
    height: ${({ $h }) => $h || '14px'};
    width: ${({ $w }) => $w || '100%'};
    margin: 4px 0;
`

export const SkeletonCard = styled.div`
    background: var(--surface);
    border: 1px solid ${GRAY_LINE};
    border-radius: 12px;
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 8px;
`

/* ── Voltar ─────────────────────────────────────────────────────── */

export const ToGoBack = styled.div`
    display: flex;
    gap: 6px;
    justify-content: center;
    align-items: center;
    padding: 18px 8px 8px;
    cursor: pointer;
    user-select: none;
    color: ${GRAY_TEXT};
    font-size: 14px;
    min-height: 44px;
    &:hover { color: ${TEAL_TEXT}; }

    @media (max-width: ${bp.mobile}) { padding: 12px 8px; font-size: 15px; }
`

export const SignMessageButtonText = styled.span``
export const SignMessageButtonTextBold = styled.span`
    font-weight: 700;
    color: ${TEAL_TEXT};
`

/* ── Modal de alerta (sem professor regente) ───────────────────── */

export const Overlay = styled.div`
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,0.4);
    backdrop-filter: blur(2px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    padding: 16px;

    @media (max-width: ${bp.mobile}) { padding: 8px; align-items: flex-end; }
`

export const Modal = styled.div`
    background: var(--surface);
    border-radius: 14px;
    padding: 24px;
    width: 100%;
    max-width: 440px;
    box-shadow: 0 12px 40px rgba(0,0,0,0.2);
    text-align: center;
    animation: ${expand} .2s ease;

    @media (max-width: ${bp.mobile}) {
        border-radius: 14px 14px 0 0;
        padding: 20px 16px;
        max-width: 100%;
    }
`

export const ModalTitle = styled.h3`
    margin: 0 0 10px;
    color: ${AMBER};
    font-size: 18px;
`

export const ModalText = styled.p`
    margin: 0 0 20px;
    color: ${GRAY_TEXT};
    font-size: 14px;
    line-height: 1.55;
`

export const ModalButton = styled.button`
    background: ${TEAL};
    color: #fff;
    border: none;
    padding: 10px 22px;
    border-radius: 8px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 700;
    min-height: 42px;
    transition: filter .12s ease;
    &:hover { filter: brightness(1.1); }
    &:focus-visible { outline: 2px solid ${TEAL_LIGHT}; outline-offset: 2px; }
`

/* ── Modal de relatório (ver / editar / apagar) ────────────────── */

export const FormCard = styled.div`
    background: var(--surface);
    border-radius: 14px;
    padding: 22px;
    width: 100%;
    max-width: 560px;
    box-shadow: 0 12px 40px rgba(0,0,0,0.2);
    max-height: 90vh;
    overflow-y: auto;
    animation: ${expand} .25s ease;

    @media (max-width: ${bp.mobile}) {
        border-radius: 14px 14px 0 0;
        padding: 18px 16px;
        max-height: 95vh;
        max-width: 100%;
    }
`

export const FormHeader = styled.div`
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    margin-bottom: 16px;
    padding-bottom: 14px;
    border-bottom: 1px solid ${GRAY_LINE};
    gap: 12px;
    flex-wrap: wrap;
`

export const FormTitle = styled.h3`
    margin: 0;
    color: ${TEAL_TEXT};
    font-size: 18px;
    font-weight: 700;

    @media (max-width: ${bp.mobile}) { font-size: 16px; }
`

export const FormSubtitle = styled.span`
    color: ${TEAL_LIGHT};
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.3px;
`

export const FormError = styled.div`
    background: var(--red-soft);
    color: ${RED};
    border: 1px solid var(--red);
    padding: 10px 12px;
    border-radius: 8px;
    font-size: 13px;
    margin-bottom: 14px;
`

export const FormActions = styled.div`
    display: flex;
    gap: 10px;
    justify-content: flex-end;
    padding-top: 14px;
    border-top: 1px solid ${GRAY_LINE};
    margin-top: 6px;
    flex-wrap: wrap;

    @media (max-width: ${bp.small}) {
        flex-direction: column-reverse;
        & > button { width: 100%; }
    }
`

const modalActionBase = css`
    border: none;
    padding: 10px 22px;
    border-radius: 8px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 700;
    min-height: 42px;
    transition: filter .12s ease, transform .12s ease;
    &:active { transform: translateY(1px); }
    &:disabled { opacity: .6; pointer-events: none; }
    &:focus-visible { outline: 2px solid ${TEAL_LIGHT}; outline-offset: 2px; }

    @media (max-width: ${bp.mobile}) { min-height: 46px; font-size: 15px; }
`

export const SaveButton = styled.button`
    ${modalActionBase}
    background: ${TEAL};
    color: #fff;
    &:hover { filter: brightness(1.1); }
`

export const CancelButton = styled.button`
    ${modalActionBase}
    background: var(--surface-2);
    color: ${GRAY_TEXT};
    border: 1px solid ${GRAY_LINE};
    font-weight: 600;
    &:hover { filter: brightness(.97); }
`

export const DeleteButton = styled.button`
    ${modalActionBase}
    background: var(--red-soft);
    color: ${RED};
    border: 1px solid var(--red);
    &:hover { filter: brightness(.97); }
`

export const QuillWrap = styled.div`
    margin-bottom: 14px;
    .ql-toolbar { border-radius: 8px 8px 0 0; border-color: ${GRAY_LINE}; }
    .ql-container { border-radius: 0 0 8px 8px; border-color: ${GRAY_LINE}; font-size: 15px; }
    .ql-editor { min-height: 200px; line-height: 1.6; color: ${TEAL_TEXT}; }
`

export const ViewBody = styled.div`
    color: ${TEAL_TEXT};
    font-size: 14px;
    line-height: 1.6;
    max-height: 50vh;
    overflow-y: auto;
    margin-bottom: 14px;
`